import {Pipe, PipeTransform} from '@angular/core';

/*
 * Extracts the username part of and email id
*/

@Pipe({ name: 'emailUsername', pure: false })
export class EmailUsername implements PipeTransform {
    transform(input: string): string {
        if (!input) {
            return input;
        }
        let indexOfSeperator = input.indexOf('@');
        return indexOfSeperator > -1 && input.length > indexOfSeperator ? input.substring(0, indexOfSeperator) : input;
    }
}


// WEBPACK FOOTER //
// ./app/common/emailusername.pipe.ts